import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AudioPlayerProvider } from "@/context/AudioPlayerContext";
import { RoleProvider } from "@/context/RoleContext";
import { MarketingLayout } from "@/components/MarketingLayout";
import { AppLayout } from "@/components/AppLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Features from "@/pages/Features";
import Security from "@/pages/Security";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Trips from "@/pages/Trips";
import TripDetail from "@/pages/TripDetail";
import TripCreate from "@/pages/TripCreate";
import TripBudget from "@/pages/TripBudget";
import Tasks from "@/pages/Tasks";
import Budget from "@/pages/Budget";
import Compliance from "@/pages/Compliance";
import SettingsPage from "@/pages/Settings";
import SharedView from "@/pages/SharedView";
import Favorites from "@/pages/Favorites";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Marketing routes - isolated layout */}
      <Route path="/" element={<MarketingLayout><Landing /></MarketingLayout>} />
      <Route path="/features" element={<MarketingLayout><Features /></MarketingLayout>} />
      <Route path="/security" element={<MarketingLayout><Security /></MarketingLayout>} />
      <Route path="/pricing" element={<MarketingLayout><Pricing /></MarketingLayout>} />
      <Route path="/contact" element={<MarketingLayout><Contact /></MarketingLayout>} />
      <Route path="/login" element={<Login />} />

      {/* App routes - authenticated layout */}
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
      <Route path="/trips" element={<ProtectedRoute><AppLayout><Trips /></AppLayout></ProtectedRoute>} />
      <Route path="/trips/new" element={<ProtectedRoute><TripCreate /></ProtectedRoute>} />
      <Route path="/trips/:tripId" element={<ProtectedRoute><AppLayout><TripDetail /></AppLayout></ProtectedRoute>} />
      <Route path="/trips/:tripId/budget" element={<ProtectedRoute><AppLayout><TripBudget /></AppLayout></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><AppLayout><Tasks /></AppLayout></ProtectedRoute>} />
      <Route path="/budget" element={<ProtectedRoute><AppLayout><Budget /></AppLayout></ProtectedRoute>} />
      <Route path="/compliance" element={<ProtectedRoute><AppLayout><Compliance /></AppLayout></ProtectedRoute>} />
      <Route path="/favorites" element={<ProtectedRoute><AppLayout><Favorites /></AppLayout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><AppLayout><SettingsPage /></AppLayout></ProtectedRoute>} />

      {/* Public shared view - no auth required */}
      <Route path="/shared/:linkId" element={<SharedView />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoleProvider>
          <AudioPlayerProvider>
            <AppRouter />
            <Toaster position="bottom-right" />
          </AudioPlayerProvider>
        </RoleProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
